@if(!fullyLoaded) {
  <div class="row justify-content-center">
    <div id="status">
        <div class="bouncing-loader">
            <div></div>
            <div></div>
            <div></div>
        </div>
    </div>
</div>
}
@else {
<div class="card">
  <div class="card-body">
    <form [formGroup]="form">
      <div class="row">
        <div class="mb-3 col-md-4 col-sm-10 col-xs-10">
          <label for="simpleinput" class="form-label">Partner*</label>
          <select class="form-select" formControlName="partner">
            <option selected value="null">
              @if(partners){Partner...} @else {Loading...}
            </option>
            @for(partner of partners; track partner.id) {
            <option value="{{ partner.id }}">{{ partner.name }}</option>
            }
          </select>
        </div>

        <div class="mb-3 col-md-4 col-sm-10 col-xs-10">
          <label for="example-email" class="form-label">Invoice number*</label>
          <input
            value="{{form.controls['invoiceNumber'].value}}"
            type="text"
            class="form-control"
            placeholder="Invoice number"
            [disabled]="true"
          />
        </div>
      </div>

      <div class="row">
        <div class="mb-3 col-md-4 col-sm-10 col-xs-10">
          <label for="simpleinput" class="form-label">Status*</label>
          <select class="form-select" formControlName="status">
            <option selected value="null">
              @if(statuses){Status...} @else {Loading...}
            </option>
            @for(status of statuses; track status.id) {
            <option value="{{ status.id }}">{{ status.name }}</option>
            }
          </select>
        </div>
        <div class="mb-3 col-md-4 col-sm-10 col-xs-10">
          <label for="example-email" class="form-label">Creation date*</label>
          <input formControlName="date" type="date" class="form-control" />
        </div>
      </div>

      <div class="row">
        <div class="mb-3 col-md-4 col-sm-10 col-xs-10">
          <label for="example-email" class="form-label">Delivery date*</label>
          <input
            formControlName="deliveryDate"
            type="date"
            class="form-control"
            min="{{ form.controls['date'].value }}"
          />
        </div>

        <div class="mb-3 col-md-4 col-sm-10 col-xs-10">
          <label for="example-email" class="form-label">Deadline*</label>
          <input
            formControlName="deadline"
            type="date"
            class="form-control"
            min="{{ form.controls['date'].value }}"
          />
        </div>
      </div>

      <div class="row">
        <label for="example-email" class="form-label">Articles</label>
        <div class="mb-3 col-md-4 col-sm-10 col-xs-10">
          <select class="form-select" formControlName="article">
            <option selected value="null">
              @if(articles){Article...} @else {Loading...}
            </option>
            @for(article of articles; track article.id) {
            <option value="{{ article.id }}">{{ article.name }}</option>
            }
          </select>
        </div>
        <div class="mb-3 col-md-4 col-sm-10 col-xs-10" (click)="addArticle()">
          <button class="btn btn-secondary" [disabled]="!articles">Add</button>
        </div>
        <div class="table-responsive-sm col-md-8">
          <table
            datatable
            [dtOptions]="dtOptions"
            [dtTrigger]="dtTrigger"
            class="table dt-responsive table-striped table-centered mb-0"
          >
            <thead class="table-dark">
              <tr>
                <th>Article</th>
                <th>Unit of measurement</th>
                <th>Quantity</th>
                <th>Price per unit</th>
                <th>Action</th>
              </tr>
            </thead>
          </table>
        </div>
      </div>
      <div class="row">
        <div class="mb-3 col-md-4 col-sm-10 col-xs-10">
          @if(submitting) {
          <button class="btn btn-secondary" disabled>
            <span
              class="spinner-border spinner-border-sm me-1"
              role="status"
              aria-hidden="true"
            ></span>
            Submitting...
          </button>
          } @else {
          <button class="btn btn-secondary" (click)="command()">
            {{ buttonText }}
          </button>
          } @if(error){<span class="p-2 text-danger">{{ error }}</span
          >}
        </div>
        <div class="mb-3 col-md-4 col-sm-10 col-xs-10 align-content-center">
          <h4 class="text-center">
            Total Due: {{ form.controls["amount"].value }}
          </h4>
        </div>
      </div>
    </form>
  </div>
</div>
}
